// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* First name after sign-up: a dialog (a sheet on phones; main.css). */

.name-onboarding-overlay {
  z-index: 10000;
}

.name-onboarding-card .form-label {
  display: block;
  margin: 8px 0 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--brand-muted);
}

.name-onboarding-error {
  margin-top: 12px;
}

.name-onboarding-submit {
  margin-top: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/NameOnboarding.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* First name after sign-up: a dialog (a sheet on phones; main.css). */\n\n.name-onboarding-overlay {\n  z-index: 10000;\n}\n\n.name-onboarding-card .form-label {\n  display: block;\n  margin: 8px 0 6px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.name-onboarding-error {\n  margin-top: 12px;\n}\n\n.name-onboarding-submit {\n  margin-top: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
